import React from "react";
import NewsletterFormComponent from "./NewsletterFormComponent";
import styles from "./blogSubscribePrompt.module.scss";

function BlogSubscribePrompt() {
    return (
        <aside className={styles.card} aria-label="Subscribe for updates">
            <h2 className={styles.heading}>Get notified about new posts</h2>
            <p className={styles.description}>
                Subscribe to get new blog posts and product updates by email.
            </p>
            <NewsletterFormComponent />
        </aside>
    );
}

export default BlogSubscribePrompt;
